module.exports = __webpack_public_path__ + "static/NurofenText_W_Bd-40c6692052eb75fb0061c5104823ed83.woff";